<template>
  <v-container class="mt-4 pa-0">
    <v-flex>
      <v-card
        color="primary"
        class="elevation-1"
        :style="{ textAlign: 'center' }"
        v-if="!!repair.length"
      >
        <v-toolbar color="primary" flat>
          <v-tooltip bottom>
            <v-toolbar-side-icon slot="activator" @click="reset()" icon>
              <v-icon>arrow_back</v-icon>
            </v-toolbar-side-icon>
            <span>Return to Barcode</span>
          </v-tooltip>
          <h2>
            <span class="hidden-xs-only">Repair Reference -</span>

            <a
              target="new"
              :href="`https://ops.bohmtech.com/web#id=${repair[0].id}&view_type=form&model=mrp.repair`"
              :style="{ color: '#F04E23', textDecoration: 'none' }"
              class="ml-2"
              >{{ repair[0].name }}</a
            >
            <span class="hidden-xs-only" v-if="repair[0].partner_id"> - {{ repair[0].partner_id[1] }}</span>
          </h2>
          <v-spacer></v-spacer>

          <h3 class="hidden-xs-only">{{ repair[0].product_id[1] }}</h3>
        </v-toolbar>

        <div v-if="repair[0].product_id[1].toLowerCase().startsWith('[apls')">
          <v-card
            color="primary"
            class="mb-5 elevation-0"
            :style="{ textAlign: 'center' }"
          >
            <h2 class="mt-2">Send to Rev Share</h2>
            <v-btn color="primary" @click="reset()">Go Home</v-btn>
          </v-card>
        </div>
        
        <div v-else-if="repair[0].x_mrp_passed === 'FAILED'">
          <v-card
            color="primary"
            class="mb-5 elevation-0"
            :style="{ textAlign: 'center' }"
          >
            <h2 class="mt-2">This watch has a failed step!</h2>
            <v-btn color="primary" @click="reset()">Go Home</v-btn>
          </v-card>
        </div>

        <div v-else-if="!hasBeenTested">
          <v-card
            color="primary"
            class="mb-5 elevation-0"
            :style="{ textAlign: 'center' }"
          >
            <h2 class="mt-2">This watch has not been tested!</h2>
            <v-btn color="primary" @click="reset()">Go Home</v-btn>
          </v-card>
        </div> 
      
        <v-stepper
          v-model="currentStep"
          class="elevation-0 mx-5"
          v-else-if="repairState === 'draft'"
        >
          <v-stepper-header class="elevation-0">
            <template v-for="(surface, sIndex) in surfaces">
              <v-stepper-step
                :key="`${sIndex + 1}-head`"
                :step="sIndex + 1"
                :complete="currentStep > sIndex + 1"
                >{{ surface.surface || "Complete" }}</v-stepper-step
              >
              <v-divider
                v-if="sIndex != surfaces.length - 1"
                :key="`${sIndex}-divider`"
              />
            </template>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content
              v-for="(surface, sIndex) in surfaces"
              :key="`${sIndex + 1}-card`"
              :step="sIndex + 1"
            >
              <v-card color="primary" class="mb-5 elevation-0" height="550px">
                <div :style="{ textAlign: 'center' }">
                  <h1 class="mb-5" v-if="surface.surfaceCode">
                    {{ surface.surface }} - ({{ surface.surfaceCode }})
                  </h1>
                </div>
                <v-layout v-if="surface.surfaceCode" row wrap justify-center>
                  <v-flex xs12 md8>
                    <div v-for="(question, qIndex) in questions" :key="qIndex">
                      <v-text-field
                        :name="`question-${sIndex + 1}-${qIndex + 1}`"
                        type="tel"
                        mask="##"
                        color="secondary"
                        outline
                        v-model="values[sIndex][qIndex]"
                        height="65"
                      >
                        <template v-slot:label>
                          <span class="py-4" :style="{ fontSize: '19px' }">{{
                            question
                          }}</span>
                        </template>
                      </v-text-field>
                    </div>
                  </v-flex>
                </v-layout>
                <div v-else>
                  <v-layout justify-center>
                    <div>
                      <h1 class="mb-3">LCD Grade</h1>
                      <div
                        class="grade-circle"
                        :style="{ color: lcdGrade.color }"
                      >
                        {{ lcdGrade.text }}
                      </div>
                    </div>
                    <div>
                      <h1 class="mb-3">Housing Grade</h1>
                      <div
                        class="grade-circle mx-5"
                        :style="{ color: housingGrade.color }"
                      >
                        {{ housingGrade.text }}
                      </div>
                    </div>
                  </v-layout>
                </div>

                <v-card-text
                  v-if="sIndex + 1 == surfaces.length"
                  class="mx-auto mt-4"
                  :style="{ width: '50%', color: '#F04E23' }"
                >
                  <h1 v-if="canBePolished">Send To Polishing</h1>
                  <h1 v-else-if="goToRevShare">Send to Revenue Share</h1>
                  <h1 v-else>Send to Verizon</h1>
                </v-card-text>
              </v-card>
              <v-btn
                color="primary"
                v-if="sIndex + 1 != surfaces.length"
                :disabled="disableButton(sIndex)"
                @click.native="continueToNextStep(sIndex)"
                >Continue</v-btn
              >

              <v-btn v-else color="primary" @click.native="submitRepair()"
                >Submit Grade</v-btn
              >
              <v-btn
                flat
                @click.native="
                  sIndex != 0 ? currentStep-- : $router.push('/watch-grading')
                "
                >{{ sIndex != 0 ? "Go Back" : "Cancel" }}</v-btn
              >
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>

        <div v-else-if="repairState === 'under_repair'">
          <v-card
            color="primary"
            class="mb-5 elevation-0"
            height="550px"
            :style="{ textAlign: 'center' }"
          >
            <h2 class="mt-5">Was this product polished?</h2>
            <v-btn color="success" @click="repairState = 'draft'">Yes</v-btn>
            <v-btn color="error" @click="notPolished()">No</v-btn>
          </v-card>
        </div>

        <div v-else>
          <v-card
            color="primary"
            class="mb-5 elevation-0"
            :style="{ textAlign: 'center' }"
          >
            <h2 class="mt-2">This repair order has been completed!</h2>
            <v-card height="550px" class="mt-5" color="primary" flat>
              <v-select
                :items="allPrinters"
                v-model="selectedPrinter"
                color="secondary"
                label="Select Printer"
                box
                :style="{ width: '50%', margin: 'auto' }"
              ></v-select>
              <v-btn color="secondary" @click="printLabel()"
                >Print Sort Label</v-btn
              >
              <v-btn color="primary" @click="reset()">Go Home</v-btn>
              <v-btn color="primary" @click="openGradeHistory()">View Grades</v-btn>
              <v-card-text
                v-if="currentStep > 1"
                class="mx-auto mt-4"
                :style="{ width: '50%', color: '#F04E23' }"
              >
                <h1 v-if="canBePolished">Send To Polishing</h1>
                <h1 v-else-if="goToRevShare">Send to Revenue Share</h1>
                <h1 v-else>Send to Verizon</h1>
              </v-card-text>
            </v-card>
          </v-card>
        </div>
      </v-card>
    </v-flex>
    <v-dialog
      v-model="scratchDialog"
      width="60%"
      persistent
      :style="{ overflow: 'hidden' }"
      transition="dialog-transition"
    >
      <v-card
        color="primary"
        :style="{
          height: '50vh',
          overflow: 'hidden',
          textAlign: 'center',
          width: '100%',
        }"
        v-if="currentSizeStatements.length"
      >
        <v-stepper v-model="sizeStep" class="elevation-0 mx-5">
          <v-stepper-header class="elevation-0">
            <template v-for="(item, sIndex) in currentSizeStatements">
              <v-stepper-step
                :key="`${sIndex + 1}-head-size`"
                :step="sIndex + 1"
                :complete="sizeStep > sIndex + 1"
                >{{ item.name }}</v-stepper-step
              >
              <v-divider
                v-if="sIndex != currentSizeStatements.length - 1"
                :key="`${sIndex}-divider-size`"
              />
            </template>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content
              v-for="(question, qIndex) in currentSizeStatements"
              :step="qIndex + 1"
              :key="qIndex"
            >
              <h2 class="mb-3">{{ question.statement }}</h2>
              <div v-for="(item, bIndex) in question.statements" :key="bIndex">
                <v-btn
                  class="mx-auto"
                  :style="{ width: '80%' }"
                  @click="valueSelected(bIndex, question)"
                  >{{ item }}</v-btn
                >
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
      

    <v-dialog v-model="gradeHistoryDialog" :width="dialogWidth">
      <v-card color="primary">
        <v-card-title>
          <h2>Grade History</h2>
        </v-card-title>
        <v-card-text>
          <v-data-table
            flat
            :headers="gradeDataHeaders"
            :pagination="gradeDataPagination"
            class="primary mx-2"
            :items="gradeHistory"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ localizeDate(props.item.evalDate, true)}}</td>
              <td class="text-xs-left">
                {{ props.item.evalBy}}
              </td>
              <td class="text-xs-left">
                {{ props.item.housingGrade }}
              </td>
              <td class="text-xs-left">
                {{ props.item.lcdGrade }}
              </td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
         
          <v-btn @click="gradeHistoryDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoginCheck from "@/mixins/LoginCheck";
import Common from "@/mixins/Common";

export default {
  name: "watch",

  data() {
    return {
      currentStep: 1,
      values: [],
      repairState: false,
      scratchDialog: false,
      sizeQuestions: [
        {
          scratch: [
            "Smaller than 5mm",
            "Smaller than 15mm larger than 5mm",
            "Larger than 15mm",
          ],
          nick: [
            "Smaller than 0.8mm",
            "Smaller than 5mm but larger than 0.8mm",
            "Larger than 5mm",
          ],
        },
        {
          scratch: [
            "Smaller than 5mm",
            "Smaller than 10mm but larger than 5mm",
            "Smaller than 15mm but larger than 10mm",
            "Larger than 15mm",
          ],
          nick: [
            "Smaller than 0.2mm",
            "Smaller than 2mm but larger than 0.2mm",
            "Larger than 2mm",
          ],
          discoloration: ["Smaller than 2mm", "Larger than 2mm"],
        },
        {
          scratch: [
            "Smaller than 5mm",
            "Smaller than 10mm but larger than 5mm",
            "Larger than 10mm x 0.8mm",
          ],
          nick: [
            "Smaller than 0.2mm",
            "Smaller than 2mm but larger than 0.2mm",
            "Smaller than 3mm but larger than 2mm",
            "Larger than 3mm",
          ],
          discoloration: [
            "Smaller than 2mm",
            "Smaller than 3mm but larger than 2mm",
            "Larger than 3mm",
          ],
        },
        {
          scratch: [
            "Smaller than 5mm",
            "Smaller than 10mm but larger than 5mm",
            "Larger than 10mm",
          ],
          nick: [
            "Smaller than 0.2mm",
            "Smaller than 2mm but larger than 0.2mm",
            "Larger than 2mm",
          ],
          discoloration: ["Smaller than 3mm", "Larger than 3mm"],
        },
      ],
      sizeStatement: [
        "The largest scratch/scuff is...",
        "This largest nick/gouge/chip/dent is...",
        "The largest crack is...",
        "The largest discoloration is...",
      ],
      currentSizeStatements: [],
      sizeStep: 1,
      report: false,
      gradeHistoryDialog: false,
   
      gradeDataHeaders: [   { text: "Grade Date", value: "evalDate" },
        { text: "Graded By", value: "evalBy" },
        { text: "Housing Grade", value: "housingGrade" },
        { text: "LCD Grade", value: "lcdGrade" }],
      gradeDataPagination: {
        rowsPerPage: 10,
        sortBy: "evalDate",
        descending: true,
        page: 1
      }
    };
  },

  mixins: [LoginCheck, Common],

  async beforeMount() {
    await this.searchServices({ serial: this.$route.params.id });
    
    this.surfaces.forEach(() => {
      this.values.push([]);
    });
    if (this.repair.length) {
      this.repairState = this.repair[0].state;
    } else {
      this.reset();
    }

    await this.getPreviousGrades(this.repair[0].id);

    await this.getAllPrinters();
    await this.getOperation({ id: this.repair[0].id });

    this.report = {
      repairID: this.repair[0].id,
      serial: this.repair[0].name,
      housingGrade: false,
      lcdGrade: false,
      rawProduct: {
        id: this.repair[0].product_id[0],
        product: this.repair[0].product_id[1],
      },
      aaCounts: { scratch: 0, nick: 0, crack: 0, discoloration: 0 },
      aaLengths: {
        scratch: false,
        nick: false,
        crack: false,
        discoloration: false,
      },
      aCounts: { scratch: 0, nick: 0, crack: 0, discoloration: 0 },
      aLengths: {
        scratch: false,
        nick: false,
        crack: false,
        discoloration: false,
      },
      bCounts: { scratch: 0, nick: 0, crack: 0, discoloration: 0 },
      bLengths: {
        scratch: false,
        nick: false,
        crack: false,
        discoloration: false,
      },
      cCounts: { scratch: 0, nick: 0, crack: 0, discoloration: 0 },
      cLengths: {
        scratch: false,
        nick: false,
        crack: false,
        discoloration: false,
      },
    };
  },

  destroyed() {
    this.$store.commit("repair/setRepair", []);
  },
  watch: {
    currentStep() {
      this.currentSizeStatements = [];
      this.sizeStep = 1;
    },
  },
  computed: {
    ...mapGetters({
      questions: "repair/getQuestions",
      surfaces: "repair/getSurfaces",
      repair: "repair/getRepair",
      possibleGrades: "repair/getGrades",
      storedPrinter: "repair/getSelectedPrinter",
      allPrinters: "repair/getAllPrinters",
      user: "app/getUser",
      previousGrades: "repair/getPreviousGrades",
      repairOperations: "repair/getRepairOperations",
      gradeHistory: "repair/getGradeHistory"
    }),

    hasBeenTested() {
      let testingStep = this.repairOperations.filter(
          (item) => item.product_id[0] == 743
      );
      if(testingStep.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    selectedPrinter: {
      get() {
        return this.storedPrinter;
      },
      set(val) {
        return this.$store.commit("repair/setSelectedPrinter", val);
      },
    },

    housingGrade() {
      let totalDefects = this.getTotalDefects();
      let gradeIndexes = [];
      let grade = this.possibleGrades[0];
      switch (true) {
        case totalDefects <= 3:
          gradeIndexes[0] = 0;
          break;
        case totalDefects <= 12:
          gradeIndexes[0] = 1;
          break;
        case totalDefects <= 18:
          gradeIndexes[0] = 2;
          break;
        case totalDefects <= 26:
          gradeIndexes[0] = 3;
          break;
        default:
          gradeIndexes[0] = 4;
          break;
      }

      let q2 = this.values[1];
      let q3 = this.values[2];
      let q4 = this.values[3];

      // Q2
      if (q2.length === 4) {
        gradeIndexes = gradeIndexes.concat(this.getLCDBorderGrades(q2));
      }

      // Q3
      if (q3.length === 4) {
        gradeIndexes = gradeIndexes.concat(this.getCaseGrades(q3));
      }

      // Q4
      if (q4.length === 4) {
        gradeIndexes = gradeIndexes.concat(this.getCaseBackGrades(q4));
      }
      let prevHousing = false;
      // if (this.previousGrades.length) {
      //   prevHousing = this.previousGrades.filter(x => {
      //       return x.grade_name == "Housing Grade"
      //   })[0]
      // }

      if (Math.max(...gradeIndexes)) {
        let returnedGrade =this.possibleGrades[Math.max(...gradeIndexes)];        
        if (prevHousing && returnedGrade.value > prevHousing.grade_value) {
          return this.possibleGrades.find(x => x.value == prevHousing.grade_value)
        } 
          return returnedGrade
      } else {
        if (prevHousing && grade.value > prevHousing.grade_value) {
          return this.possibleGrades.find(x => x.value == prevHousing.grade_value)
        } 
          return grade;
      }
    },

    lcdGrade() {
      let q1 = this.values[0];
      let gradeIndexes = [];
      let grade = this.possibleGrades[0];
      if (q1.length == 4) {
        gradeIndexes = this.getLCDGrades(q1);
      }

      if (!!gradeIndexes.length) {
        return this.possibleGrades[Math.max(...gradeIndexes)];
      } else {
        return grade;
      }
    },

    finalGrade() {
      return this.lcdGrade.value >= this.housingGrade.value
        ? this.housingGrade
        : this.lcdGrade;
    },
    canBePolished() {
      return (
        this.housingGrade.value > this.lcdGrade.value &&
        this.repair[0].state !== "under_repair" &&
        this.housingGrade.value > 79
      );
    },
    goToRevShare() {
      return this.housingGrade.value < 79 || this.lcdGrade.value < 79;
    },

    whoGraded() {
      console.log(this.gradeHistory)
      if (this.gradeHistory.length) {
        return this.gradeHistory
      } else {
        return false
      }
    },

    dialogWidth() {
      if (this.$vuetify.breakpoint.xs) {
        return "100%";
      } else if (this.$vuetify.breakpoint.sm) {
        return "55%";
      } 
      return "55%";
    }

  },

  methods: {
    ...mapActions({
      searchServices: "repair/searchServices",
      sendToPolishing: "repair/sendToPolishing",
      submitGradeToOdoo: "repair/submitGrade",
      completeWatchRepair: "repair/completeWatchRepair",
      getAllPrinters: "repair/getAllPrinters",
      printSortLabel: "repair/printSortLabel",
      reportGrade: "repair/reportGrade",
      getPreviousGrades: "repair/getPreviousGrades",
      getOperation: "repair/getRepairOperations",
      getGradehistory: "repair/fetchGradeHistory"
    }),

    async openGradeHistory() {
      await this.getGradehistory({repairID: this.repair[0].id})
      this.gradeHistoryDialog = true;
    },

    continueToNextStep(index) {
      const evalLCD = values => {
        this.report.aaCounts = {
          scratch: values[0],
          nick: values[1],
          crack: values[2],
          discoloration: values[3],
        };

        if (
          values[2] > 0 ||
          values[0] > 10 ||
          values[1] > 10 ||
          values[3] > 1
        ) {
          this.currentStep++;
        } else if (values[0] > 0 && values[1] < 1) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 1,
              name: "Scratches/Scuffs",
              statement: this.sizeStatement[0],
              statements: this.sizeQuestions[this.currentStep - 1].scratch,
            },
          ];
        } else if (values[0] < 1 && values[1] > 0) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 2,
              name: "Nick/Gouges/Chips/Dents",
              statement: this.sizeStatement[1],
              statements: this.sizeQuestions[this.currentStep - 1].nick,
            },
          ];
        } else if (values[0] > 0 && values[1] > 0) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 1,
              name: "Scratches/Scuffs",
              statement: this.sizeStatement[0],
              statements: this.sizeQuestions[this.currentStep - 1].scratch,
            },
            {
              id: 2,
              name: "Nick/Gouges/Chips/Dents",
              statement: this.sizeStatement[1],
              statements: this.sizeQuestions[this.currentStep - 1].nick,
            },
          ];
        } else this.currentStep++;
      };
      const evalLCDBorder = values => {
        this.report.aCounts = {
          scratch: values[0],
          nick: values[1],
          crack: values[2],
          discoloration: values[3],
        };
        if (values[0] > 10 || values[1] > 5 || values[2] > 0 || values[3] > 1) {
          this.currentStep++;
        } else if (values[0] > 0 && values[1] < 1 && values[3] < 1) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 1,
              name: "Scratches/Scuffs",
              statement: this.sizeStatement[0],
              statements: this.sizeQuestions[this.currentStep - 1].scratch,
            },
          ];
        } else if (values[0] < 1 && values[1] > 0 && values[3] < 1) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 2,
              name: "Nick/Gouges/Chips/Dents",
              statement: this.sizeStatement[1],
              statements: this.sizeQuestions[this.currentStep - 1].nick,
            },
          ];
        } else if (values[0] < 1 && values[1] < 1 && values[3] > 0) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 4,
              name: "Discolorations",
              statement: this.sizeStatement[3],
              statements:
                this.sizeQuestions[this.currentStep - 1].discoloration,
            },
          ];
        } else if (values[0] > 0 && values[1] > 0 && values[3] < 1) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 1,
              name: "Scratches/Scuffs",
              statement: this.sizeStatement[0],
              statements: this.sizeQuestions[this.currentStep - 1].scratch,
            },
            {
              id: 2,
              name: "Nick/Gouges/Chips/Dents",
              statement: this.sizeStatement[1],
              statements: this.sizeQuestions[this.currentStep - 1].nick,
            },
          ];
        } else if (values[0] > 0 && values[1] < 1 && values[3] > 0) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 1,
              name: "Scratches/Scuffs",
              statement: this.sizeStatement[0],
              statements: this.sizeQuestions[this.currentStep - 1].scratch,
            },
            {
              id: 4,
              name: "Discolorations",
              statement: this.sizeStatement[3],
              statements:
                this.sizeQuestions[this.currentStep - 1].discoloration,
            },
          ];
        } else if (values[0] < 1 && values[1] > 0 && values[3] > 0) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 2,
              name: "Nick/Gouges/Chips/Dents",
              statement: this.sizeStatement[1],
              statements: this.sizeQuestions[this.currentStep - 1].nick,
            },
            {
              id: 4,
              name: "Discolorations",
              statement: this.sizeStatement[3],
              statements:
                this.sizeQuestions[this.currentStep - 1].discoloration,
            },
          ];
        } else if (values[0] > 0 && values[1] > 0 && values[3] > 0) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 1,
              name: "Scratches/Scuffs",
              statement: this.sizeStatement[0],
              statements: this.sizeQuestions[this.currentStep - 1].scratch,
            },
            {
              id: 2,
              name: "Nick/Gouges/Chips/Dents",
              statement: this.sizeStatement[1],
              statements: this.sizeQuestions[this.currentStep - 1].nick,
            },
            {
              id: 4,
              name: "Discolorations",
              statement: this.sizeStatement[3],
              statements:
                this.sizeQuestions[this.currentStep - 1].discoloration,
            },
          ];
        } else this.currentStep++;
      };
      const evalCase = values => {
        this.report.bCounts = {
          scratch: values[0],
          nick: values[1],
          crack: values[2],
          discoloration: values[3],
        };
        if (values[0] > 10 || values[1] > 3 || values[2] > 0 || values[3] > 2) {
          this.currentStep++;
        } else if (
          values[0] > 0 &&
          values[1] < 1 &&
          values[2] < 1 &&
          values[3] < 1
        ) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 1,
              name: "Scratches/Scuffs",
              statement: this.sizeStatement[0],
              statements: this.sizeQuestions[this.currentStep - 1].scratch,
            },
          ];
        } else if (
          values[0] < 1 &&
          values[1] > 0 &&
          values[2] < 1 &&
          values[3] < 1
        ) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 2,
              name: "Nick/Gouges/Chips/Dents",
              statement: this.sizeStatement[1],
              statements: this.sizeQuestions[this.currentStep - 1].nick,
            },
          ];
        } else if (
          values[0] < 1 &&
          values[1] < 1 &&
          values[2] < 1 &&
          values[3] > 0
        ) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 4,
              name: "Discolorations",
              statement: this.sizeStatement[3],
              statements:
                this.sizeQuestions[this.currentStep - 1].discoloration,
            },
          ];
        } else if (
          values[0] > 0 &&
          values[1] > 0 &&
          values[2] > 0 &&
          values[3] > 0
        ) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 1,
              name: "Scratches/Scuffs",
              statement: this.sizeStatement[0],
              statements: this.sizeQuestions[this.currentStep - 1].scratch,
            },
            {
              id: 2,
              name: "Nick/Gouges/Chips/Dents",
              statement: this.sizeStatement[1],
              statements: this.sizeQuestions[this.currentStep - 1].nick,
            },
            {
              id: 4,
              name: "Discolorations",
              statement: this.sizeStatement[3],
              statements:
                this.sizeQuestions[this.currentStep - 1].discoloration,
            },
          ];
        } else if (
          values[0] > 0 &&
          values[1] < 1 &&
          values[2] > 0 &&
          values[3] > 0
        ) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 1,
              name: "Scratches/Scuffs",
              statement: this.sizeStatement[0],
              statements: this.sizeQuestions[this.currentStep - 1].scratch,
            },
            {
              id: 4,
              name: "Discolorations",
              statement: this.sizeStatement[3],
              statements:
                this.sizeQuestions[this.currentStep - 1].discoloration,
            },
          ];
        } else if (
          values[0] > 0 &&
          values[1] > 0 &&
          values[2] > 0 &&
          values[3] < 1
        ) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 1,
              name: "Scratches/Scuffs",
              statement: this.sizeStatement[0],
              statements: this.sizeQuestions[this.currentStep - 1].scratch,
            },
            {
              id: 2,
              name: "Nick/Gouges/Chips/Dents",
              statement: this.sizeStatement[1],
              statements: this.sizeQuestions[this.currentStep - 1].nick,
            },
          ];
        } else if (
          values[0] > 0 &&
          values[1] > 0 &&
          values[2] < 1 &&
          values[3] > 0
        ) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 1,
              name: "Scratches/Scuffs",
              statement: this.sizeStatement[0],
              statements: this.sizeQuestions[this.currentStep - 1].scratch,
            },
            {
              id: 2,
              name: "Nick/Gouges/Chips/Dents",
              statement: this.sizeStatement[1],
              statements: this.sizeQuestions[this.currentStep - 1].nick,
            },
            {
              id: 4,
              name: "Discolorations",
              statement: this.sizeStatement[3],
              statements:
                this.sizeQuestions[this.currentStep - 1].discoloration,
            },
          ];
        } else if (
          values[0] < 1 &&
          values[1] > 0 &&
          values[2] > 0 &&
          values[3] > 0
        ) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 2,
              name: "Nick/Gouges/Chips/Dents",
              statement: this.sizeStatement[1],
              statements: this.sizeQuestions[this.currentStep - 1].nick,
            },
            {
              id: 4,
              name: "Discolorations",
              statement: this.sizeStatement[3],
              statements:
                this.sizeQuestions[this.currentStep - 1].discoloration,
            },
          ];
        } else if (
          values[0] < 1 &&
          values[1] > 0 &&
          values[2] < 1 &&
          values[3] > 0
        ) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 2,
              name: "Nick/Gouges/Chips/Dents",
              statement: this.sizeStatement[1],
              statements: this.sizeQuestions[this.currentStep - 1].nick,
            },
            {
              id: 4,
              name: "Discolorations",
              statement: this.sizeStatement[3],
              statements:
                this.sizeQuestions[this.currentStep - 1].discoloration,
            },
          ];
        } else if (
          values[0] > 0 &&
          values[1] > 0 &&
          values[2] < 1 &&
          values[3] < 1
        ) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 1,
              name: "Scratches/Scuffs",
              statement: this.sizeStatement[0],
              statements: this.sizeQuestions[this.currentStep - 1].scratch,
            },
            {
              id: 2,
              name: "Nick/Gouges/Chips/Dents",
              statement: this.sizeStatement[1],
              statements: this.sizeQuestions[this.currentStep - 1].nick,
            },
          ];
        } else if (
          values[0] > 0 &&
          values[1] < 1 &&
          values[2] > 0 &&
          values[3] < 1
        ) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 1,
              name: "Scratches/Scuffs",
              statement: this.sizeStatement[0],
              statements: this.sizeQuestions[this.currentStep - 1].scratch,
            },
          ];
        } else if (
          values[0] > 0 &&
          values[1] < 1 &&
          values[2] < 1 &&
          values[3] > 0
        ) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 1,
              name: "Scratches/Scuffs",
              statement: this.sizeStatement[0],
              statements: this.sizeQuestions[this.currentStep - 1].scratch,
            },
            {
              id: 4,
              name: "Discolorations",
              statement: this.sizeStatement[3],
              statements:
                this.sizeQuestions[this.currentStep - 1].discoloration,
            },
          ];
        } else if (
          values[0] < 1 &&
          values[1] > 0 &&
          values[2] > 0 &&
          values[3] < 1
        ) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 2,
              name: "Nick/Gouges/Chips/Dents",
              statement: this.sizeStatement[1],
              statements: this.sizeQuestions[this.currentStep - 1].nick,
            },
          ];
        } else if (
          values[0] < 1 &&
          values[1] < 1 &&
          values[2] > 0 &&
          values[3] > 0
        ) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 4,
              name: "Discolorations",
              statement: this.sizeStatement[3],
              statements:
                this.sizeQuestions[this.currentStep - 1].discoloration,
            },
          ];
        } else this.currentStep++;
      };
      const evalCaseBack = values => {
        this.report.cCounts = {
          scratch: values[0],
          nick: values[1],
          crack: values[2],
          discoloration: values[3],
        };
        if (values[0] > 10 || values[1] > 5 || values[2] > 1 || values[3] > 5) {
          this.currentStep++;
        } else if (values[0] > 0 && values[1] < 1 && values[3] < 1) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 1,
              name: "Scratches/Scuffs",
              statement: this.sizeStatement[0],
              statements: this.sizeQuestions[this.currentStep - 1].scratch,
            },
          ];
        } else if (values[0] < 1 && values[1] > 0 && values[3] < 1) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 2,
              name: "Nick/Gouges/Chips/Dents",
              statement: this.sizeStatement[1],
              statements: this.sizeQuestions[this.currentStep - 1].nick,
            },
          ];
        } else if (values[0] < 1 && values[1] < 1 && values[3] > 0) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 4,
              name: "Discolorations",
              statement: this.sizeStatement[3],
              statements:
                this.sizeQuestions[this.currentStep - 1].discoloration,
            },
          ];
        } else if (values[0] > 0 && values[1] > 0 && values[3] < 1) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 1,
              name: "Scratches/Scuffs",
              statement: this.sizeStatement[0],
              statements: this.sizeQuestions[this.currentStep - 1].scratch,
            },
            {
              id: 2,
              name: "Nick/Gouges/Chips/Dents",
              statement: this.sizeStatement[1],
              statements: this.sizeQuestions[this.currentStep - 1].nick,
            },
          ];
        } else if (values[0] > 0 && values[1] < 1 && values[3] > 0) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 1,
              name: "Scratches/Scuffs",
              statement: this.sizeStatement[0],
              statements: this.sizeQuestions[this.currentStep - 1].scratch,
            },
            {
              id: 4,
              name: "Discolorations",
              statement: this.sizeStatement[3],
              statements:
                this.sizeQuestions[this.currentStep - 1].discoloration,
            },
          ];
        } else if (values[0] < 1 && values[1] > 0 && values[3] > 0) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 2,
              name: "Nick/Gouges/Chips/Dents",
              statement: this.sizeStatement[1],
              statements: this.sizeQuestions[this.currentStep - 1].nick,
            },
            {
              id: 4,
              name: "Discolorations",
              statement: this.sizeStatement[3],
              statements:
                this.sizeQuestions[this.currentStep - 1].discoloration,
            },
          ];
        } else if (values[0] > 0 && values[1] > 0 && values[3] > 0) {
          this.scratchDialog = true;
          this.currentSizeStatements = [
            {
              id: 1,
              name: "Scratches/Scuffs",
              statement: this.sizeStatement[0],
              statements: this.sizeQuestions[this.currentStep - 1].scratch,
            },
            {
              id: 2,
              name: "Nick/Gouges/Chips/Dents",
              statement: this.sizeStatement[1],
              statements: this.sizeQuestions[this.currentStep - 1].nick,
            },
            {
              id: 4,
              name: "Discolorations",
              statement: this.sizeStatement[3],
              statements:
                this.sizeQuestions[this.currentStep - 1].discoloration,
            },
          ];
        } else this.currentStep++;
      };

      switch (index) {
        case 0:
          evalLCD(this.values[index]);
          break;
        case 1:
          evalLCDBorder(this.values[index]);
          break;
        case 2:
          evalCase(this.values[index]);
          break;
        case 3:
          evalCaseBack(this.values[index]);
          break;
        default:
          break;
      }
    },

    valueSelected(value, question) {
      let qID = question.id;
      let currentIndex = this.currentStep;
      let scratchValue = this.values[this.currentStep - 1][0];
      let nickValue = this.values[this.currentStep - 1][1];
      let crackValue = this.values[this.currentStep - 1][2];
      let colorValue = this.values[this.currentStep - 1][3];

      if (this.currentStep === 1) {
        switch (qID) {
          case 1:
            switch (value) {
              case 0:
                this.report.aaLengths.scratch = "< 5mm";
                if (nickValue < 1) {
                  this.currentStep++;
                  this.scratchDialog = false;
                } else {
                  this.sizeStep++;
                }
                break;
              case 1:
                this.report.aaLengths.scratch = "15mm < 5mm";
                if (scratchValue < 10) {
                  scratchValue = 10;
                }
                if (nickValue < 1) {
                  this.currentStep++;
                  this.scratchDialog = false;
                } else {
                  this.sizeStep++;
                }
                break;
              default:
                this.report.aaLengths.scratch = "> 15mm";
                if (scratchValue < 15) scratchValue = 15;
                if (nickValue < 1) {
                  this.currentStep++;
                  this.scratchDialog = false;
                } else {
                  this.sizeStep++;
                }
                break;
            }
            break;

          default:
            switch (value) {
              case 0:
                this.report.aaLengths.nick = "< 0.8mm";
                this.currentStep++;
                this.scratchDialog = false;
                break;
              case 1:
                this.report.aaLengths.nick = "5mm < 0.8mm";
                if (nickValue < 10) nickValue = 10;
                this.currentStep++;
                this.scratchDialog = false;
                break;
              default:
                this.report.aaLengths.nick = "> 5mm";
                if (nickValue < 11) nickValue = 11;
                this.currentStep++;
                this.scratchDialog = false;
                break;
            }
            break;
        }
      } else if (this.currentStep === 2) {
        switch (qID) {
          case 1:
            switch (value) {
              case 0:
                this.report.aLengths.scratch = "< 5mm";
                if (nickValue < 1 && colorValue < 1) {
                  this.currentStep++;
                  this.scratchDialog = false;
                } else {
                  this.sizeStep++;
                }
                break;
              case 1:
                this.report.aLengths.scratch = "10mm < 5mm";
                if (scratchValue < 4) {
                  scratchValue = 4;
                }

                if (nickValue < 1 && colorValue < 1) {
                  this.currentStep++;
                  this.scratchDialog = false;
                } else {
                  this.sizeStep++;
                }
                break;
              case 2:
                this.report.aLengths.scratch = "15mm < 10mm";
                if (scratchValue < 10) {
                  scratchValue = 10;
                }

                if (nickValue < 1 && colorValue < 1) {
                  this.currentStep++;
                  this.scratchDialog = false;
                } else {
                  this.sizeStep++;
                }
                break;
              default:
                this.report.aLengths.scratch = "> 15mm";
                if (scratchValue < 11) scratchValue = 11;

                if (nickValue < 1 && colorValue < 1) {
                  this.currentStep++;
                  this.scratchDialog = false;
                } else {
                  this.sizeStep++;
                }
                break;
            }
            break;
          case 2:
            switch (value) {
              case 0:
                this.report.aLengths.nick = "< 0.2mm";
                if (colorValue < 1) {
                  this.currentStep++;
                  this.scratchDialog = false;
                } else {
                  this.sizeStep++;
                }
                break;
              case 1:
                this.report.aLengths.nick = "2mm < 0.2mm";
                if (nickValue < 3) {
                  nickValue = 3;
                }
                if (colorValue < 1) {
                  this.currentStep++;
                  this.scratchDialog = false;
                } else {
                  this.sizeStep++;
                }
                break;
              default:
                this.report.aLengths.nick = "> 2mm";
                if (nickValue < 6) nickValue = 6;
                if (colorValue < 1) {
                  this.currentStep++;
                  this.scratchDialog = false;
                } else {
                  this.sizeStep++;
                }
                break;
            }
            break;
          default:
            switch (value) {
              case 0:
                this.report.aLengths.discoloration = "< 2mm";
                this.currentStep++;
                this.scratchDialog = false;
                break;
              default:
                this.report.aLengths.discoloration = "> 2mm";
                if (colorValue < 2) colorValue = 2;
                this.currentStep++;
                this.scratchDialog = false;
                break;
            }
            break;
        }
      } else if (this.currentStep === 3) {
        switch (qID) {
          case 1:
            switch (value) {
              case 0:
                this.report.bLengths.scratch = "< 5mm";
                if (nickValue > 0 || colorValue > 0) {
                  this.sizeStep++;
                } else {
                  this.currentStep++;
                  this.scratchDialog = false;
                }
                break;
              case 1:
                this.report.bLengths.scratch = "10mm < 5mm";
                if (scratchValue < 8) scratchValue = 8;
                if (nickValue > 0 || colorValue > 0) {
                  this.sizeStep++;
                } else {
                  this.currentStep++;
                  this.scratchDialog = false;
                }
                break;
              default:
                this.report.bLengths.scratch = "> 10mm";
                if (scratchValue < 9) scratchValue = 9;
                if (nickValue > 0 || colorValue > 0) {
                  this.sizeStep++;
                } else {
                  this.currentStep++;
                  this.scratchDialog = false;
                }
                break;
            }
            break;
          case 2:
            switch (value) {
              case 0:
                this.report.bLengths.nick = "< 0.2mm";
                if (colorValue > 0) {
                  this.sizeStep++;
                } else {
                  this.currentStep++;
                  this.scratchDialog = false;
                }
                break;
              case 1:
                this.report.bLengths.nick = "2mm < 0.2mm";
                if (nickValue < 3) nickValue = 3;
                if (colorValue > 0) {
                  this.sizeStep++;
                } else {
                  this.currentStep++;
                  this.scratchDialog = false;
                }
                break;
              default:
                this.report.bLengths.nick = "> 2mm";
                if (nickValue < 4) nickValue = 4;
                if (colorValue > 0) {
                  this.sizeStep++;
                } else {
                  this.currentStep++;
                  this.scratchDialog = false;
                }
                break;
            }
            break;
          default:
            switch (value) {
              case 0:
                this.report.bLengths.discoloration = "< 2mm";
                this.currentStep++;
                this.scratchDialog = false;
                break;
              case 1:
                this.report.bLengths.discoloration = "3mm < 2mm";
                if (colorValue < 2) colorValue = 2;
                this.currentStep++;
                this.scratchDialog = false;
                break;
              default:
                this.report.bLengths.discoloration = "> 3mm";
                if (colorValue < 3) colorValue = 3;
                this.currentStep++;
                this.scratchDialog = false;
                break;
            }

            break;
        }
      } else if (this.currentStep === 4) {
        switch (qID) {
          case 1:
            switch (value) {
              case 0:
                this.report.cLengths.scratch = "< 5mm";
                if (nickValue < 1 && colorValue < 1) {
                  this.currentStep++;
                  this.scratchDialog = false;
                } else {
                  this.sizeStep++;
                }
                break;
              case 1:
                this.report.cLengths.scratch = "10mm < 5mm";
                if (scratchValue < 10) scratchValue = 10;
                if (nickValue < 1 && colorValue < 1) {
                  this.currentStep++;
                  this.scratchDialog = false;
                } else {
                  this.sizeStep++;
                }
                break;
              default:
                this.report.cLengths.scratch = "> 10mm";
                if (scratchValue < 11) scratchValue = 11;
                if (nickValue < 1 && colorValue < 1) {
                  this.currentStep++;
                  this.scratchDialog = false;
                } else {
                  this.sizeStep++;
                }
                break;
            }
            break;
          case 2:
            switch (value) {
              case 0:
                this.report.cLengths.nick = "< 0.2mm";
                if (colorValue < 1) {
                  this.currentStep++;
                  this.scratchDialog = false;
                } else {
                  this.sizeStep++;
                }
                break;
              case 1:
                this.report.cLengths.nick = "3mm < 0.2mm";
                if (nickValue < 5) nickValue = 5;
                if (colorValue < 1) {
                  this.currentStep++;
                  this.scratchDialog = false;
                } else {
                  this.sizeStep++;
                }
                break;
              default:
                this.report.cLengths.nick = "> 3mm";
                if (nickValue < 6) nickValue = 6;
                if (colorValue < 1) {
                  this.currentStep++;
                  this.scratchDialog = false;
                } else {
                  this.sizeStep++;
                }
                break;
            }
            break;

          default:
            switch (value) {
              case 0:
                this.report.cLengths.discoloration = "< 3mm";
                this.currentStep++;
                this.scratchDialog = false;
                break;
              default:
                this.report.cLengths.discoloration = "> 3mm";
                if (colorValue < 6) colorValue = 6;
                this.currentStep++;
                this.scratchDialog = false;
                break;
            }
            break;
        }
      }

      this.values[currentIndex - 1][0] = scratchValue;
      this.values[currentIndex - 1][1] = nickValue;
      this.values[currentIndex - 1][2] = crackValue;
      this.values[currentIndex - 1][3] = colorValue;
      this.values.push([]);
      this.values.pop();
    },

    goBack() {
      window.location.reload();
    },

    async submitRepair() {
      let id = this.repair[0].id;
      let grades = [
        {
          grade_name: "Housing Grade",
          grade_result: this.housingGrade.text,
          grade_value: this.housingGrade.value,
          repair_id: id,
          is_final: false,
        },
        {
          grade_name: "LCD Grade",
          grade_result: this.lcdGrade.text,
          grade_value: this.lcdGrade.value,
          repair_id: id,
          is_final: false,
        },
      ];
      if (this.canBePolished) {
        const res = await this.sendToPolishing({
          id,
          housing_grade: this.housingGrade.text,
          lcd_grade: this.lcdGrade.text,
          polished: true,
        });
        if (res.success) {
          this.sendReport();
          this.storeGrade(grades, "Product is ready for polishing");
          this.reset();
        } else {
          this.$store.dispatch("app/setSnackbar", {
            text: res.message,
            color: "red",
          });
        }
      } else {
        const res = await this.completeWatchRepair({
          id,
          housing_grade: this.housingGrade.text,
          lcd_grade: this.lcdGrade.text,
          final_grade: this.finalGrade.text,
          polished: false,
        });
        if (res.success) {
          this.sendReport();
          grades[0].is_final = true;
          grades[1].is_final = true;
          this.storeGrade(grades, "Final sku assigned!");
          this.repairState = "done";
        } else {
          this.$store.dispatch("app/setSnackbar", {
            text: res.message,
            color: "red",
          });
        }
      }
    },

    sendReport() {
      this.report.housingGrade = this.housingGrade.text;
      this.report.lcdGrade = this.lcdGrade.text;
      this.report.evalBy = this.user.displayName;
      this.reportGrade(this.report);
    },
    async notPolished() {
      const res = await this.completeWatchRepair({
        id: this.repair[0].id,
        housing_grade: "",
        lcd_grade: "",
        final_grade: "",
        polished: false,
      });
      if (res.success) {
        this.$store.dispatch("app/setSnackbar", {
          text: "Repair complete!",
          color: "green",
        });

        this.repairState = "done";
      } else {
        this.$store.dispatch("app/setSnackbar", {
          text: res.message,
          color: "red",
        });
      }
    },

    async storeGrade(grades, message) {
      grades.forEach(async grade => {
        await this.submitGradeToOdoo({ grade });
      });
      await this.$store.dispatch("app/setSnackbar", {
        text: message,
        color: "green",
      });
    },

    async printLabel() {
      if (!this.selectedPrinter) {
        this.$store.dispatch("app/setSnackbar", {
          text: "Please Select a Printer!",
          color: "red",
        });
      } else {
        const res = await this.printSortLabel({
          repair_id: this.repair[0].id,
          printer: this.selectedPrinter,
        });

        if (res.success) {
          this.$store.dispatch("app/setSnackbar", {
            text: "Sort label printed to " + this.selectedPrinter,
            color: "green",
          });
        } else {
          this.$store.dispatch("app/setSnackbar", {
            text: res.message,
            color: "red",
          });
        }
      }
    },

    disableButton(sIndex) {
      if (this.values[sIndex].length !== this.questions.length) return true;

      if (
        this.values[sIndex]
          .map(value => {
            if (Number.isNaN(value) || value === "") {
              return true;
            }
          })
          .includes(true)
      ) {
        return true;
      }
    },

    getTotalDefects() {
      let totalDefects = 0;
      this.values.forEach((parent, pIndex) => {
        parent.forEach((child, cIndex) => {
          this.values[pIndex][cIndex] = parseInt(child);
          if (child && pIndex !== 0) {
            totalDefects += parseInt(child);
          }
        });
      });

      return totalDefects;
    },

    getLCDGrades(question) {
      let gradeIndexes = [];
      switch (true) {
        case question[0] <= 1:
          gradeIndexes[0] = 0;
          break;
        case question[0] <= 3:
          gradeIndexes[0] = 1;
          break;
        case question[0] <= 5:
          gradeIndexes[0] = 2;
          break;
        default:
          gradeIndexes[0] = 4;
          break;
      }
      switch (true) {
        case question[1] == 0:
          gradeIndexes[1] = 0;
          break;
        case question[1] <= 1:
          gradeIndexes[1] = 3;
          break;
        default:
          gradeIndexes[1] = 4;
          break;
      }
      switch (true) {
        case question[2] == 0:
          gradeIndexes[2] = 0;
          break;
        default:
          gradeIndexes[2] = 4;
          break;
      }
      switch (true) {
        case question[3] == 0:
          gradeIndexes[3] = 0;
          break;
        default:
          gradeIndexes[3] = 4;
          break;
      }

      return gradeIndexes;
    },

    getLCDBorderGrades(question) {
      let gradeIndexes = [];
      switch (true) {
        case question[0] <= 3:
          gradeIndexes[0] = 0;
          break;
        case question[0] <= 4:
          gradeIndexes[0] = 1;
          break;
        case question[0] <= 10:
          gradeIndexes[0] = 2;
          break;
        default:
          gradeIndexes[0] = 4;
          break;
      }
      switch (true) {
        case question[1] == 0:
          gradeIndexes[1] = 0;
          break;
        case question[1] <= 2:
          gradeIndexes[1] = 1;
          break;
        case question[1] <= 4:
          gradeIndexes[1] = 2;
          break;
        case question[1] <= 6:
          gradeIndexes[1] = 3;
          break;
        default:
          gradeIndexes[1] = 4;
          break;
      }
      switch (true) {
        case question[2] == 0:
          gradeIndexes[2] = 0;
          break;
        default:
          gradeIndexes[2] = 4;
          break;
      }
      switch (true) {
        case question[3] == 0:
          gradeIndexes[3] = 0;
          break;
        case question[3] <= 3:
          gradeIndexes[3] = 3;
          break;
        default:
          gradeIndexes[3] = 4;
          break;
      }

      return gradeIndexes;
    },

    getCaseGrades(question) {
      let gradeIndexes = [];
      switch (true) {
        case question[0] <= 3:
          gradeIndexes[0] = 0;
          break;
        case question[0] <= 5:
          gradeIndexes[0] = 1;
          break;
        case question[0] <= 8:
          gradeIndexes[0] = 2;
          break;
        default:
          gradeIndexes[0] = 4;
          break;
      }
      switch (true) {
        case question[1] == 0:
          gradeIndexes[1] = 0;
          break;
        case question[1] <= 1:
          gradeIndexes[1] = 1;
          break;
        case question[1] <= 3:
          gradeIndexes[1] = 2;
          break;
        default:
          gradeIndexes[1] = 4;
          break;
      }
      switch (true) {
        case question[2] == 0:
          gradeIndexes[2] = 0;
          break;
        default:
          gradeIndexes[2] = 4;
          break;
      }
      switch (true) {
        case question[3] == 0:
          gradeIndexes[3] = 0;
          break;
        case question[3] <= 2:
          gradeIndexes[3] = 2;
          break;
        default:
          gradeIndexes[3] = 3;
          break;
      }

      return gradeIndexes;
    },

    getCaseBackGrades(question) {
      let gradeIndexes = [];
      switch (true) {
        case question[0] <= 3:
          gradeIndexes[0] = 0;
          break;
        case question[0] <= 10:
          gradeIndexes[0] = 2;
          break;
        default:
          gradeIndexes[0] = 3;
          break;
      }
      switch (true) {
        case question[1] == 0:
          gradeIndexes[1] = 0;
          break;
        case question[1] <= 1:
          gradeIndexes[1] = 1;
          break;
        case question[1] <= 2:
          gradeIndexes[1] = 2;
          break;
        case question[1] <= 5:
          gradeIndexes[1] = 3;
          break;
        default:
          gradeIndexes[1] = 4;
          break;
      }
      switch (true) {
        case question[2] == 0:
          gradeIndexes[2] = 0;
          break;
        default:
          gradeIndexes[2] = 4;
          break;
      }
      switch (true) {
        case question[3] == 0:
          gradeIndexes[3] = 0;
          break;
        case question[3] <= 2:
          gradeIndexes[3] = 2;
          break;
        case question[3] <= 5:
          gradeIndexes[3] = 3;
          break;
        default:
          gradeIndexes[3] = 4;
          break;
      }

      return gradeIndexes;
    },

    reset() {
      this.$store.commit("repair/setRepair", []);
      this.currentStep = 1;
      this.items = [];
      this.values = [];
      this.$router.push("/watch-grading");
    },
  },
};
</script>

<style>
.grade-circle {
  width: 400px;
  height: 400px;
  border-radius: 50%;
  font-size: 90px;
  line-height: 400px;
  text-align: center;
  border: 1px solid;
}
</style>
